import { SegmentedControl, SegmentedControlProps } from '@mantine/core';

import { SubscriptionBillingCycle } from 'models';

type SubscriptionBillingCycleInputProps = {
    value: SubscriptionBillingCycle;
    onChange: (value: SubscriptionBillingCycle) => void;
} & Omit<SegmentedControlProps, 'value' | 'onChange' | 'data'>;

export const SubscriptionBillingCycleInput = ({ value, onChange, ...props }: SubscriptionBillingCycleInputProps) => {
    return (
        <SegmentedControl
            size="md"
            value={value}
            onChange={(value) => {
                onChange(value as SubscriptionBillingCycle);
            }}
            data={[
                {
                    value: SubscriptionBillingCycle.MONTHLY,
                    label: 'Monthly',
                },
                {
                    value: SubscriptionBillingCycle.YEARLY,
                    label: 'Annually',
                },
            ]}
            {...props}
        />
    );
};
